import Logo from '../Logo'

export default function Footer() {
  return (
    <footer className="border-t border-white/[0.06]">
      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 py-10 sm:flex-row">
        <Logo size="sm" tone="dark" />
        <p className="text-caption text-white/50">
          © {new Date().getFullYear()} notes2board. Built by Consolices.
        </p>
      </div>
    </footer>
  )
}
